import { useString as s } from "../../../../../components/StringProvider";
import { ReactComponent as Icon } from "../../../../../assets/editor/justify.svg";
import ToolbarButton from "./ToolbarButton";

const JustifyButton = ({ onClick, active }) => {
  return (
    <ToolbarButton
      active={active}
      onClick={onClick}
      label={s("editor.buttons.justify.label", "Justify")}
    >
      <Icon />
    </ToolbarButton>
  );
};

export default JustifyButton;
